import AssertionPresetSetupBase, {
  AssertionPresetContent,
  AssertionPresetSetupProps,
} from "./AssertionPresetSetupBase";

const groundTruthPresetContent: AssertionPresetContent = {
  groundingLabel: "Ground truth response",
  groundingHint:
    "Required. Paste the reference response the generated output should be compared against.",
  groundingPlaceholder:
    "Example: You can return the item within 30 days if it is unused and you have the receipt.",
  assertionTitle: "What should the judge check?",
  assertionHint: "Use focused checks. Avoid vague criteria like “good answer.”",
  assertionPlaceholder: "Example: The output states the correct return window.",
  defaultAssertions: [
    "The generated response is semantically equivalent to the ground truth response.",
    "The generated response does not add facts missing from the ground truth response.",
    "The generated response includes the important facts from the ground truth response.",
  ],
  resultLabel: "Ground truth assertions",
  missingText: "Add a ground truth response and at least one assertion.",
  tableInputText: "Prompt variables, ground truth response, and assertion checks.",
};

const GroundTruthPresetSetup = (props: AssertionPresetSetupProps) => (
  <AssertionPresetSetupBase
    presetType="GROUND_TRUTH_COMPARE"
    content={groundTruthPresetContent}
    {...props}
  />
);

export default GroundTruthPresetSetup;
